module.exports = __webpack_public_path__ + "img/foto uabc.3958129e.jpeg";